<div class="checklist-container">
    <div>
        <div class="qr-container" *ngIf="qrCodeURL">
            <qrcode class="waiver-qrcode" [width]="120" [qrdata]="qrCodeURL" colordark="rgba(30, 30, 30, 1)" usesvg="true">
            </qrcode>
        </div>
    </div>
    <div *ngFor="let product of reservation.reservedProducts">
        <!-- <div class="info-container">
          <p-panel header="{{ 'bikeshop.rentals.booking.checklist.rental_leaving' | translate }}" [toggleable]="true"
            [collapsed]="!(reservation.reservationStatusID <= 20)">
            <div class="vertical-checklist">
              <div *ngFor="let checklistItem of getfilteredLeavingChecklist(product.checklist)">
                <div>
                  <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
                    {{checklistItem.description}}
                  </div>
                  <div *ngIf="!checklistItem.frontRearCheck">
                    <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
                      <p-checkbox [(ngModel)]="checklistItem.defaultValue" [binary]="true"
                        (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                    </div>
                    <div *ngIf="checklistItem.controlType === 'TEXT'">
                      <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue"
                        (blur)="updateChecklistItem(checklistItem)" />
                    </div>
                  </div>
                  <div *ngIf="checklistItem.frontRearCheck">
                    <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
                      <span>F</span>
                      <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"
                        (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                      <span>R</span>
                      <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"
                        (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                    </div>
                    <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
                      <span>F</span>
                      <input type="text" pInputText [(ngModel)]="checklistItem.frontValue"
                        (blur)="updateChecklistItem(checklistItem)" />
                      <span>R</span>
                      <input type="text" pInputText [(ngModel)]="checklistItem.rearValue"
                        (blur)="updateChecklistItem(checklistItem)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row margin-top-16">
              <div class="col-md-4">
                <button pButton type="button" class="p-button-raised full-width" (click)="fileUpload.click()"
                  label="{{ 'bikeshop.modal.update_job_card.attachments.add_attachment' | translate}} {{ POSName }}"></button>
                <input #fileUpload type="file" accept="image/*;capture=camera" style="display: none"
                  (change)="addAttachment($event, product, 'CheckOut')">
              </div>
              <div class="col-md-2">
                <div class="qr-container">
                  <qrcode qrdata="Pedego Demo" colordark="rgba(30, 30, 30, 1)" [size]="256" [level]="'M'" usesvg="true"></qrcode>
                </div>
              </div>
              <div class="col-md-6"></div>
            </div>
            <div class="attachments-container" *ngIf="showProductAttachments(product, 'CheckOut').length > 0">
              <div *ngFor="let attachment of showProductAttachments(product, 'CheckOut')" class="attachment">
                <img [src]="attachment.attachmentURL" [ngClass]="{'uploading' : attachment.uploading }">
              </div>
            </div>

          </p-panel>
        </div>
        <div class="info-container" *ngIf="reservation.reservationStatusID >= 30">
          <p-panel header="{{ 'bikeshop.rentals.booking.checklist.rental_returning' | translate }}" [toggleable]="true"
            [collapsed]="!(reservation.reservationStatusID > 20)">
            <div class="vertical-checklist">
              <div *ngFor="let checklistItem of getfilteredReturningChecklist(product.checklist)">
                <div>
                  <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
                    {{checklistItem.description}}
                  </div>
                  <div *ngIf="!checklistItem.frontRearCheck">
                    <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
                      <p-checkbox [(ngModel)]="checklistItem.defaultValue" [binary]="true"
                        (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                    </div>
                    <div *ngIf="checklistItem.controlType === 'TEXT'">
                      <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue"
                        (blur)="updateChecklistItem(checklistItem)" />
                    </div>
                  </div>
                  <div *ngIf="checklistItem.frontRearCheck">
                    <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
                      <span>F</span>
                      <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"
                        (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                      <span>R</span>
                      <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"
                        (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                    </div>
                    <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
                      <span>F</span>
                      <input type="text" pInputText [(ngModel)]="checklistItem.frontValue"
                        (blur)="updateChecklistItem(checklistItem)" />
                      <span>R</span>
                      <input type="text" pInputText [(ngModel)]="checklistItem.rearValue"
                        (blur)="updateChecklistItem(checklistItem)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-top-16">
              <div class="col-md-4">
                <button pButton type="button" class="p-button-raised full-width" (click)="fileUpload.click()"
                  label="{{ 'bikeshop.modal.update_job_card.attachments.add_attachment' | translate}} {{ POSName }}"></button>
                <input #fileUpload type="file" accept="image/*;capture=camera" style="display: none"
                  (change)="addAttachment($event, product, 'CheckIn')">
              </div>
              <div class="col-md-2">
                <div class="qr-container">
                  <qrcode qrdata="Pedego Demo" colordark="rgba(30, 30, 30, 1)" [size]="256" [level]="'M'" usesvg="true"></qrcode>
                </div>
              </div>
              <div class="col-md-6"></div>
            </div>
            <div class="attachments-container" *ngIf="showProductAttachments(product, 'CheckIn').length > 0">
              <div *ngFor="let attachment of showProductAttachments(product, 'CheckIn')" class="attachment">
                <img [src]="attachment.attachmentURL" [ngClass]="{'uploading' : attachment.uploading }">
              </div>
            </div>
          </p-panel>
        </div> -->


        <div class="info-container">
            <div class="product-header-container">
                <div class="bike-header">{{product.brand}} {{product.model}} {{product.color}} ({{product.size}}) -
                    {{product.serialNumber}}</div>
                <div class="attachments-button-container">
                    <div>
                        <!--            todo (dcorbett) no {{ POSName }}-->
                        <button pButton type="button" class="p-button-raised" (click)="fileUpload.click()"
                                label="{{ 'bikeshop.modal.update_job_card.attachments.add_attachment' | translate}} "></button>
                        <input #fileUpload type="file" accept="image/*,capture=camera" style="display: none"
                               (change)="addAttachment($event, product)">
                    </div>
                </div>
            </div>
            <div class="attachments-container" *ngIf="showProductAttachments(product).length > 0">
                <div *ngFor="let attachment of showProductAttachments(product);let i = index" class="attachment">
                    <img [src]="attachment.attachmentURL" [ngClass]="{'uploading' : attachment.uploading }">
                    <div>{{attachment.attachmentName}}</div>
                    <div (click)="deleteAttachment(attachment)" class="delete-attachment">
                        <div class="hubtiger-delete"></div>
                    </div>
                    <div (click)="openAttachment(attachment)" class="open-attachment">
                        <div class="fa fa-eye"></div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>

<p-confirmDialog></p-confirmDialog>
